import { ref } from 'vue';

let showErrorFn = null;

export function registerErrorHandler(fn) {
  showErrorFn = fn;
}

export function showGlobalError(message) {
  if (typeof showErrorFn === 'function') {
    showErrorFn(message);
  } else {
    console.error('Global error handler not registered yet:', message);
  }
}